import React from 'react';
import PropTypes from 'prop-types';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CloseIcon from '@mui/icons-material/Close';
import { Box } from '@mui/material';
import Drawer from '@mui/material/Drawer';
import { styled } from '@mui/material/styles';

import Button from '../../../../../components/Button';
import IconButton from '../../../../../components/IconButton';
import { JOB_CATEGORY } from '../../../../../constants/jobInformation';
import theme, { navigationBarHeight } from '../../../../../theme';
import CancellationShiftCard from '../../LongTermJobDetailView/subComponent/CancellationShiftCard';

const RootBox = styled(Box)(() => ({
  height: '100%',
  width: '100%',
  padding: theme.spacing(2, 8),
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  gap: '20px',
}));

const HeaderBox = styled(Box)(() => ({
  width: '100%',
}));

const HeaderBoxTypography = styled(Box)(() => ({
  fontSize: `${theme.components.workflow.typography.defaultTitleFontSize}`,
  fontFamily: `${theme.components.workflow.typography.boldFont}`,
  color: `${theme.components.workflow.palette.font.default.transitionPageFontColor}`,
}));
const DescriptionBoxTypgraphy = styled(Box)(() => ({
  fontSize: '16px',
  fontFamily: 'Barlow',
  color: '#333357',
}));

const BasicDrawer = ({
  headerIcon,
  header,
  subHeader,
  content,
  isOpen,
  onClose,
  actionButton,
  goBackButton,
  type,
  selectedJob,
}) => (
  <Drawer
    anchor="right"
    open={isOpen}
    onClose={onClose}
    PaperProps={{ sx: { maxWidth: '576px', paddingTop: navigationBarHeight, height: '100vh' } }}
  >
    <HeaderBox>
      <IconButton
        iconElement={<CloseIcon />}
        onClick={() => onClose()}
        size="small"
        sx={{ marginLeft: 0.5, marginTop: 0.5, position: 'fixed' }}
      />
    </HeaderBox>
    <RootBox>
      {headerIcon}
      <HeaderBoxTypography>{`${header}`}</HeaderBoxTypography>
      {type === JOB_CATEGORY.shift && <CancellationShiftCard job={selectedJob} />}
      <DescriptionBoxTypgraphy>{`${subHeader}`}</DescriptionBoxTypgraphy>
      {content}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
          alignSelf: 'flex-end',
        }}
      >
        {goBackButton || (
          <Box>
            <Button
              onClick={onClose}
              type="outlined"
              startIcon={<ArrowBackIcon sx={{ color: theme.button.palette.secondary }} />}
            >
              Go Back
            </Button>
          </Box>
        )}

        <Box>{actionButton}</Box>
      </Box>
    </RootBox>
  </Drawer>
);

BasicDrawer.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  actionButton: PropTypes.shape({}),
  goBackButton: PropTypes.shape({}),
  headerIcon: PropTypes.shape({}),
  header: PropTypes.string,
  subHeader: PropTypes.string,
  type: PropTypes.string,
  selectedJob: PropTypes.shape({}),
  content: PropTypes.shape({}),
};

export default BasicDrawer;
